import angular from 'angular';
import uiRouter from 'angular-ui-router';
import sentqueriesComponent from './sentqueries.component';

let sentqueriesModule = angular.module('sentqueries', [
  uiRouter
])

.component('sentqueries', sentqueriesComponent);

export default sentqueriesModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/sentqueries/sentqueries.js